import type { Child } from "zyra";
import { href, type Page } from "../content";
import type { SiteState } from "../app/site-state";
export function DocLink(props: {
  site: SiteState;
  page: Page;
  class?: string;
  children?: Child;
}) {
  const { router, menu, current } = props.site;
  return (
    <router.Link
      href={href(props.page)}
      class={props.class}
      onClick={() => {
        menu.value = false;
      }}
      aria-current={current.value === props.page ? "page" : undefined}
    >
      {props.children ?? props.page.title}
    </router.Link>
  );
}
